export default __webpack_public_path__ + "static/media/cloud-2.b340adea.png";